import { Typography } from '@material-ui/core';
import { StyledTableCell } from './tableStyle';
import moment from 'moment';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { Tcard } from './mainTcard';
import { useContext } from 'react';
import { TCaredBookingDashboardContext } from '../tCaredBookingDashboard-Provider';
import SaturdayList from './saturdayList';

export default function WeekdaysList(props) {
    const { label, index, isShowCount, countList, dt, mainCardList, isDragReadonly, mainHead, droppable_Id, countKey, ShowSat } = props;
    const { legendItems, handleTcardOpen, shortListByTrailter } = useContext(TCaredBookingDashboardContext);

    let sortedList = shortListByTrailter(mainCardList, label);

    return (
        <StyledTableCell align="center" key={index} className="card-body-container">
            <div className={mainHead ? 'card-body-container-main-header' : 'card-body-container-header'}>
                <Typography className="card-body-container-header-label">
                    {label}
                    {isShowCount && (
                        <span className="card-body-container-header-count">
                            {countList.find((k) => moment(k.tCardsBookingDate).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD'))?.[countKey] || 0}
                        </span>
                    )}
                </Typography>
            </div>
            {/* DND Droppable Area */}
            <Droppable droppableId={droppable_Id} direction="vertical" isDropDisabled={isDragReadonly}>
                {(provided, snapshot) => {
                    return (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className={`card-body-container-main-wrapper custom-scroll ${snapshot.isDraggingOver ? 'droppable-active' : ''}`}
                            // style={{ minHeight: '400px', overflowY: 'auto', position: 'relative' }}
                        >
                            {sortedList.length === 0 ? (
                                <div className={`card-body-container-main-wrapper-no-record ${snapshot.isDraggingOver ? 'is-drag-target' : ''}`}>
                                    <span>{snapshot.isDraggingOver ? 'Drop Here' : 'No Record Found'}</span>
                                </div>
                            ) : (
                                sortedList.map((k, idx) => (
                                    <Draggable key={k.tCardsID} draggableId={k.tCardsID.toString()} index={idx} isDragDisabled={isDragReadonly}>
                                        {(provided, dragSnapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className={`tcard-drag-item ${dragSnapshot.isDragging ? 'is-dragging' : ''}`}
                                                style={{
                                                    ...provided.draggableProps.style
                                                }}
                                            >
                                                <Tcard
                                                    legendItems={legendItems}
                                                    days={k.days}
                                                    handleTcardOpen={handleTcardOpen}
                                                    date={k.bd}
                                                    customer={k.cust}
                                                    isLoanVehicle={k.loanVehicle}
                                                    registration={k.reg}
                                                    textColor={k.tc}
                                                    color={k.bgc}
                                                    tCardsID={k.tCardsID}
                                                    breakdown={k.breakdown}
                                                    wn={k.wn}
                                                    vsc={k.vsc}
                                                    breakdownStatus={k.breakdownStatus}
                                                    breakdownTime={k.breakdownTime}
                                                    pt={k.pt}
                                                    workDetails={k.workDetails}
                                                    technicians={k.technicians}
                                                    status={{
                                                        recall: k.recall,
                                                        tacho: k.tacho,
                                                        mot: k.mot,
                                                        repair: k.repair,
                                                        inspection: k.inspection,
                                                        cd: k.cd,
                                                        waiting: k.waiting,
                                                        service: k.service,
                                                        ns: k.ns
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))
                            )}
                            {snapshot.isDraggingOver && sortedList.length > 0 && (
                                <div className={'card-body-container-main-wrapper-no-record is-drag-target'}>
                                    <span>Drop Here</span>
                                </div>
                            )}
                            {provided.placeholder}
                        </div>
                    );
                }}
            </Droppable>
            <div>
                <Typography
                    style={{
                        textAlign: 'center',
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        fontSize: 12
                    }}
                />
            </div>
        </StyledTableCell>
    );
}
